import React, { useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './Form.css';
import { useSnackbar } from 'react-simple-snackbar';
import emailjs from '@emailjs/browser';

function ContactUsForm() {
  const formRef = useRef(null);
  const [submitting, setSubmitting] = useState(false);

  const options = {
    position: 'bottom-center',
    style: {
      backgroundColor: 'midnightblue',
      border: '2px solid lightgreen',
      color: 'lightblue',
      fontFamily: 'Menlo, monospace',
      fontSize: '20px',
      textAlign: 'center',
    },
    closeStyle: {
      color: 'lightcoral',
      fontSize: '16px',
    },
  };

  const [openSnackbar] = useSnackbar(options);

  const sendEmail = async (e) => {
    e.preventDefault();
    if (!formRef.current) return;

    try {
      setSubmitting(true);

      // Prefer reading from env vars if possible
      const SERVICE_ID = 'service_6ewuimr';
      const TEMPLATE_ID = 'template_7g184wt';
      const PUBLIC_KEY = 'XT0TSraALZx9RbyPM';

      await emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY);

      openSnackbar('Thanks for contacting us! We’ll get back to you shortly.');
      // Reset the form
      formRef.current.reset();
    } catch (err) {
      // Make sure we pass a string, not an object
      const message =
        (err && (err.text || err.message)) ||
        'Something went wrong while sending your message.';
      openSnackbar(`Error: ${message}`);
      // Also helpful while debugging:
      console.error('EmailJS error:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form ref={formRef} className="contactUs-form" onSubmit={sendEmail} noValidate>
      <Form.Group className="mb-3" controlId="user_name">
        <Form.Label>Full Name</Form.Label>
        <Form.Control required type="text" name="user_name" placeholder="Syncom UAE" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="user_email">
        <Form.Label>Email address</Form.Label>
        <Form.Control required type="email" name="user_email" placeholder="Enter your email address here" />
      </Form.Group>

      {/* Use a unique controlId and type="tel" for phone numbers */}
      <Form.Group className="mb-3" controlId="user_phone">
        <Form.Label>Phone Number</Form.Label>
        <Form.Control required type="tel" name="user_number" placeholder="Enter your phone number here" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="message">
        <Form.Label>Comment</Form.Label>
        <Form.Control required as="textarea" rows={6} name="message" />
      </Form.Group>

      <Button
        size="lg"
        className="contact-us-button"
        type="submit"
        disabled={submitting}
      >
        {submitting ? 'Submitting…' : 'Submit'}
      </Button>
    </Form>
  );
}

export default ContactUsForm;
